import { combineReducers } from 'redux'
import {
    SOCKET,
    USER,
    LANG,
    PAYMENT_MODE,
    POINT,
    POINT_TICKET,
    PAYMENTS,
    PASSWORD,
    UPLOAD_IMG_BLOBURL,
    COUPON_STATE,
    ACCOUNTSTATUS_STATE,
    THEME,
    LIKE_TEMPLATES,
    LASTVIEW_TEMPLATES,
    ADMIN,
    BLOCK_USERS,

    MAKE_STATE,
    TEMPLATES_STATE,
    MY_VIDEO_STATE,
    MY_SHORTS_STATE,
    LIKED_VIDEO_STATE,
    EDITOR_STATE,
    GALLERY_STATE,
    GALLERY_DETAIL_STATE,
    USER_GALLERY_STATE,
    MY_GALLERY_STATE,
    ORDER_STATE,
    MY_PROFILE_URL_STATE,
    UNREAD_NOTI_COUNT_STATE,
    NOTI_AVAILABLE_STATE,

    LOGIN_POPUP_SHOW_STATE,
    SIGNUP_POPUP_SHOW_STATE,

    CURRENT_PATH_STATE,
    VIDEO09_PAYMENTS_STATE,

    CREDITS_STATE,
    CREDITS_PRODUCTS_STATE,

    WORKSPACE_CAPACITY_STATE,
} from '../action'

const reducerGenerator = (state, action, type) => {
    const keys = Object.keys(state)
    const key = keys.length > 0 ? keys[0] : 'key'
    switch (action.type) {
        case type:
            return {
                ...state,
                [key]: action.value
            }
        default:
            return state
    }
}

const socketStore = (state = { socket: null }, action) => reducerGenerator(state, action, SOCKET)
const userStore = (state = { user: undefined }, action) => reducerGenerator(state, action, USER)
const langStore = (state = { lang: 'ko' }, action) => reducerGenerator(state, action, LANG)
const paymentModeStore = (state = { paymentMode: {} }, action) => reducerGenerator(state, action, PAYMENT_MODE)
const pointStore = (state = { point: 0 }, action) => reducerGenerator(state, action, POINT)
const pointTicketStore = (state = { pointTicket: null }, action) => reducerGenerator(state, action, POINT_TICKET)
const paymentsStore = (state = { payments: [] }, action) => reducerGenerator(state, action, PAYMENTS)
const passwordStore = (state = { password: undefined }, action) => reducerGenerator(state, action, PASSWORD)
const uploadImgBloburlStore = (state = { uploadImgBloburl: [] }, action) => reducerGenerator(state, action, UPLOAD_IMG_BLOBURL)
const couponStore = (state = { coupons: [] }, action) => reducerGenerator(state, action, COUPON_STATE)
const accountStatusStore = (state = { accountStatus: {} }, action) => reducerGenerator(state, action, ACCOUNTSTATUS_STATE)
const themeStore = (state = { theme: undefined }, action) => reducerGenerator(state, action, THEME)
const likeTemplatesStore = (state = { likeTemplates: [] }, action) => reducerGenerator(state, action, LIKE_TEMPLATES)
const lastViewTemplatesStore = (state = { lastViewTemplates: [] }, action) => reducerGenerator(state, action, LASTVIEW_TEMPLATES)
const adminStore = (state = { grantOptions: undefined }, action) => reducerGenerator(state, action, ADMIN)
const blockUserStore = (state = { blockUsers: [] }, action) => reducerGenerator(state, action, BLOCK_USERS)

const makeStateStore = (state = { makeState: undefined }, action) => reducerGenerator(state, action, MAKE_STATE)
const templatesStateStore = (state = { templatesState: undefined }, action) => reducerGenerator(state, action, TEMPLATES_STATE)
const myVideoStateStore = (state = { myVideoState: undefined }, action) => reducerGenerator(state, action, MY_VIDEO_STATE)
const myShortsStateStore = (state = { myShortsState: undefined }, action) => reducerGenerator(state, action, MY_SHORTS_STATE)
const likedVideoStateStore = (state = { likedVideoState: undefined }, action) => reducerGenerator(state, action, LIKED_VIDEO_STATE)
const editorStateStore = (state = { editorState: undefined }, action) => reducerGenerator(state, action, EDITOR_STATE)
const galleryStateStore = (state = { galleryState: undefined }, action) => reducerGenerator(state, action, GALLERY_STATE)
const galleryDetailStateStore = (state = { galleryDetailState: undefined }, action) => reducerGenerator(state, action, GALLERY_DETAIL_STATE)
const userGalleryStateStore = (state = { userGalleryState: undefined }, action) => reducerGenerator(state, action, USER_GALLERY_STATE)
const myGalleryStateStore = (state = { myGalleryState: undefined }, action) => reducerGenerator(state, action, MY_GALLERY_STATE)
const orderStateStore = (state = { orderState: undefined }, action) => reducerGenerator(state, action, ORDER_STATE)
const myProfileURLStore = (state = { myProfileURL: undefined }, action) => reducerGenerator(state, action, MY_PROFILE_URL_STATE)
const unreadNotiCountStore = (state = { unreadNotiCount: undefined }, action) => reducerGenerator(state, action, UNREAD_NOTI_COUNT_STATE)
const notiAvailableStore = (state = { isNotiAvailable: false }, action) => reducerGenerator(state, action, NOTI_AVAILABLE_STATE)

const loginPopupShowStore = (state = { isShowLoginPopup: false }, action) => reducerGenerator(state, action, LOGIN_POPUP_SHOW_STATE)
const signUpPopupShowStore = (state = { isShowSignUpPopup: false }, action) => reducerGenerator(state, action, SIGNUP_POPUP_SHOW_STATE)

const currentPathStore = (state = { currentPath: '' }, action) => reducerGenerator(state, action, CURRENT_PATH_STATE)

const paymentsStateStore = (state = { paymentsState: undefined }, action) => reducerGenerator(state, action, VIDEO09_PAYMENTS_STATE)

const creditsStateStore = (state = { creditsState: undefined }, action) => reducerGenerator(state, action, CREDITS_STATE)
const creditsProductsStateStore = (state = { creditsProductsState: undefined }, action) => reducerGenerator(state, action, CREDITS_PRODUCTS_STATE)

const workspaceCapacityStateStore = (state = { capacityData: { total: 0, used: 0 } }, action) => reducerGenerator(state, action, WORKSPACE_CAPACITY_STATE)

export default combineReducers({
    socketStore,
    userStore,
    langStore,
    paymentModeStore,
    pointStore,
    pointTicketStore,
    paymentsStore,
    passwordStore,
    uploadImgBloburlStore,
    couponStore,
    accountStatusStore,
    themeStore,
    likeTemplatesStore,
    lastViewTemplatesStore,
    adminStore,
    blockUserStore,

    makeStateStore,
    templatesStateStore,
    myVideoStateStore,
    myShortsStateStore,
    likedVideoStateStore,
    editorStateStore,
    galleryStateStore,
    galleryDetailStateStore,
    userGalleryStateStore,
    myGalleryStateStore,
    orderStateStore,
    myProfileURLStore,
    unreadNotiCountStore,
    notiAvailableStore,

    loginPopupShowStore,
    signUpPopupShowStore,
    currentPathStore,

    paymentsStateStore,

    creditsStateStore,
    creditsProductsStateStore,

    workspaceCapacityStateStore
})